import { useToday } from './useToday';

/**
 * useAttentionCount — derives the "needs attention" badge count from the
 * existing TodaySnapshot. Single source of truth so the bottom-tab badge,
 * Today-header pill, and OS app-badge all agree.
 *
 * Returns 0 while loading / on error so we never render a misleading count.
 * The underlying useToday hook polls every 30s + on window focus so the
 * badge stays close-to-live even without push delivery.
 */
export function useAttentionCount(slug: string): number {
  const { data } = useToday(slug);
  if (!data) return 0;
  const n = data.needs_attention;
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
}
